__turbopack_context__.v({
  "container": "ButtonMenuDesktop-module__HG2dDa__container",
  "fadeInItems": "ButtonMenuDesktop-module__HG2dDa__fadeInItems",
  "spacing--lg": "ButtonMenuDesktop-module__HG2dDa__spacing--lg",
  "spacing--md": "ButtonMenuDesktop-module__HG2dDa__spacing--md",
  "spacing--sm": "ButtonMenuDesktop-module__HG2dDa__spacing--sm",
  "spacing--xl": "ButtonMenuDesktop-module__HG2dDa__spacing--xl",
  "spacing--xs": "ButtonMenuDesktop-module__HG2dDa__spacing--xs",
  "spacing--xxl": "ButtonMenuDesktop-module__HG2dDa__spacing--xxl",
  "spacing--xxs": "ButtonMenuDesktop-module__HG2dDa__spacing--xxs",
  "spacing--xxxl": "ButtonMenuDesktop-module__HG2dDa__spacing--xxxl",
  "spacing--xxxs": "ButtonMenuDesktop-module__HG2dDa__spacing--xxxs",
});
